import { Component, OnInit } from '@angular/core';

export interface Sklop {
  value: string;
  viewValue: string;
}

export interface Spremenljivka {
  value: string;
  viewValue: string;
}

export interface Regija {
  value: string;
  viewValue: string;
}

export interface Sezona {
  value: string;
  viewValue: string;
}

export interface Scenarij {
  value: string;
  viewValue: string;
}

export interface Obdobje {
  value: string;
  viewValue: string;
}

export interface TempRazmere {
  value: string;
  viewValue: string;
}

export interface TempKazalniki {
  value: string;
  viewValue: string;
}

export interface PadKazalniki {
  value: string;
  viewValue: string;
}

export interface IzjemnePadavine {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css']
})
export class FilterComponent implements OnInit {
  izbira: Sklop[] = [
    {value: 'temp-0', viewValue: 'Temperatura'},
    {value: 'pad-1', viewValue: 'Padavine'},
    {value: 'vodBil-2', viewValue: 'Vodna bilanca'},
    {value: 'hidrSpr-3', viewValue: 'Hidrološke spremenljivke'},
    {value: 'veter-4', viewValue: 'Veter'}
  ];

  spremenljivka: Spremenljivka[] = [
    {value: 'spr-0', viewValue: 'Povprečna temperatura'},
    {value: 'spr-1', viewValue: 'Najvišja temperatura'},
    {value: 'spr-2', viewValue: 'Najnižja temperatura'},
    {value: 'spr-3', viewValue: 'Temperaturni kazalniki'},
    {value: 'spr-4', viewValue: 'Temperaturne razmere za rast rastlin'},
    {value: 'spr-5', viewValue: 'Višina padavin'},
    {value: 'spr-6', viewValue: 'Izjemne padavine'},
    {value: 'spr-7', viewValue: 'Trendi izjemnih padavin'},
    {value: 'spr-8', viewValue: 'Padavinski kazalniki'},
    {value: 'spr-9', viewValue: 'Referenčna evapotranspiracija'},
    {value: 'spr-10', viewValue: 'Vodni primanjkljaj'},
    {value: 'spr-11', viewValue: 'Vodni primanjkljaj nad 0 mm'},
    {value: 'spr-12', viewValue: 'Napajanje podzemnih voda'},
    {value: 'spr-13', viewValue: 'Trendi vodnega primanjkljaja'},
    {value: 'spr-14', viewValue: 'Srednji pretoki'},
    {value: 'spr-15', viewValue: 'Veliki pretoki'},
    {value: 'spr-16', viewValue: 'Mali pretoki'},
    {value: 'spr-17', viewValue: 'Povratne dobe za velike pretoke'},
    {value: 'spr-18', viewValue: 'Povratne dobe letnih visokovodnih konic'},
    {value: 'spr-19', viewValue: 'Povrpečna hitrost vetra'}
  ];

  tempRazmere: TempRazmere[] = [
    {value: 'tmpRaz-0', viewValue: 'Povprečna temperatura tal na globini 5 cm (april-junij)'},
    {value: 'tmpRaz-1', viewValue: 'Povprečna temperatura tal na globini 5 cm (julij-september)'},
    {value: 'tmpRaz-2', viewValue: 'Olistanje divjega kostanja'},
    {value: 'tmpRaz-3', viewValue: 'Olistanje bukve'},
    {value: 'tmpRaz-4', viewValue: 'Olistanje lipe'},
    {value: 'tmpRaz-5', viewValue: 'Začetek rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-6', viewValue: 'Začetek rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-7', viewValue: 'Dolžina rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-8', viewValue: 'Dolžina rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-9', viewValue: 'Konec rastne dobe za temperaturni prag 5 °C'},
    {value: 'tmpRaz-10', viewValue: 'Konec rastne dobe za temperaturni prag 10 °C'},
    {value: 'tmpRaz-11', viewValue: 'Zadnja spomladanska pozeba (0 °C)'},
    {value: 'tmpRaz-12', viewValue: 'Zadnja spomladanska pozeba (-2 °C)'},
    {value: 'tmpRaz-13', viewValue: 'Prva jesenska pozeba (0 °C)'},
    {value: 'tmpRaz-14', viewValue: 'Prva jesenska pozeba (-2 °C)'},
    {value: 'tmpRaz-15', viewValue: 'Število dni s spomladansko pozebo (0 °C)'},
    {value: 'tmpRaz-16', viewValue: 'Število dni s spomladansko pozebo (-2 °C)'},
    {value: 'tmpRaz-17', viewValue: 'Število dni z jesensko pozebo (0 °C)'},
    {value: 'tmpRaz-18', viewValue: 'Število dni z jesensko pozebo (-2 °C)'},
    {value: 'tmpRaz-19', viewValue: 'Varnostna rezerva pred spomladansko pozebo (0 °C)'},
    {value: 'tmpRaz-20', viewValue: 'Varnostna rezerva pred spomladansko pozebo (-2 °C)'},
    {value: 'tmpRaz-21', viewValue: 'Varnostna rezerva pred jesensko pozebo (0 °C)'},
    {value: 'tmpRaz-22', viewValue: 'Varnostna rezerva pred jesensko pozebo (-2 °C)'},
    {value: 'tmpRaz-23', viewValue: 'Temperatura tal na globini 5 cm'},
    {value: 'tmpRaz-24', viewValue: 'Olistanje drevja'},
    {value: 'tmpRaz-25', viewValue: 'Začetek rastne dobe'},
    {value: 'tmpRaz-26', viewValue: 'Dolžina rastne dobe'},
    {value: 'tmpRaz-27', viewValue: 'Konec rastne dobe'},
    {value: 'tmpRaz-28', viewValue: 'Zadnja spomladanska pozeba'},
    {value: 'tmpRaz-29', viewValue: 'Prva jesenska pozeba'},
    {value: 'tmpRaz-30', viewValue: 'Varnostna rezerva pred spomladansko pozebo'},
    {value: 'tmpRaz-31', viewValue: 'Varnostna rezerva pred jesensko pozebo'}
  ];

  tempKazalniki: TempKazalniki[] = [
    {value: 'tmpKaz-0', viewValue: 'Kazalnik vročine pozitiven (EHF)'},
    {value: 'tmpKaz-1', viewValue: 'Število vročinskih valov (po definiciji EHF)'},
    {value: 'tmpKaz-2', viewValue: 'Dolžina vročinskega vala (po definiciji EHF)'},
    {value: 'tmpKaz-3', viewValue: 'Magnituda vročinskega vala (HWMId)'},
    {value: 'tmpKaz-4', viewValue: 'Število vročinskih valov (po definiciji HWMId)'},
    {value: 'tmpKaz-5', viewValue: 'Dolžina vročinskega vala (po definiciji HWMId'},
    {value: 'tmpKaz-6', viewValue: 'Skupna dolžina toplih obdobij (WSDI)'},
    {value: 'tmpKaz-7', viewValue: 'Število toplih dni (SU)'},
    {value: 'tmpKaz-8', viewValue: 'Število vročih dni'},
    {value: 'tmpKaz-9', viewValue: 'Število tropskih noči (TR)'},
    {value: 'tmpKaz-10', viewValue: 'Kazalnik najtoplejših dni (TX90p)'},
    {value: 'tmpKaz-11', viewValue: 'Kazalnik mraza negativen (ECF)'},
    {value: 'tmpKaz-12', viewValue: 'Število obdobij hudega mraza (po definiciji ECF)'},
    {value: 'tmpKaz-13', viewValue: 'Dolžina obdobja hudega mraza (po definiciji ECF)'},
    {value: 'tmpKaz-14', viewValue: 'Skupna dolžina hladnih obdobij (CSDI)'},
    {value: 'tmpKaz-15', viewValue: 'Število hladnih dni (FD)'},
    {value: 'tmpKaz-16', viewValue: 'Število ledenih dni (ID)'},
    {value: 'tmpKaz-17', viewValue: 'Kazalnik najhladnejših dni (TN10p)'}
  ];

  padKazalniki: PadKazalniki[] = [
    {value: 'padKaz-0', viewValue: 'Dolžina najdaljšega suhega obdobja v letu (CDD)'},
    {value: 'padKaz-1', viewValue: 'Dolžina najdaljšega mokrega obdobja v letu (CWD)'},
    {value: 'padKaz-2', viewValue: 'Letna višina padavin iz najbolj mokrih dni (R95pTOT)'},
    {value: 'padKaz-3', viewValue: 'Število dni na leto z več kot 0,1 mm padavin'},
    {value: 'padKaz-4', viewValue: 'Število dni na leto z več kot 1 mm padavin'},
    {value: 'padKaz-5', viewValue: 'Število dni na leto z več kot 10 mm padavin (R10mm)'},
    {value: 'padKaz-6', viewValue: 'Število dni na leto z več kot 20 mm padavin'},
    {value: 'padKaz-7', viewValue: 'Število dni na leto z več kot 50 mm padavin'},
    {value: 'padKaz-8', viewValue: 'Največja dnevna višina padavin (Rx1day)'},
    {value: 'padKaz-9', viewValue: 'Največja petdnevna višina padavin (Rx5day)'}
  ];

  izjemnePadavine: IzjemnePadavine[] = [
    {value: 'izjemnePadavine-0', viewValue: 'Največja enodnevna višina padavin'},
    {value: 'izjemnePadavine-1', viewValue: 'Največja tridnevna višina padavin'},
    {value: 'izjemnePadavine-2', viewValue: 'Največja petdnevna višina padavin'}
  ];

  regija: Regija[] = [
    {value: 'reg-0', viewValue: 'Slovenija'},
    {value: 'reg-1', viewValue: 'Posočje'},
    {value: 'reg-2', viewValue: 'Osrednja'},
    {value: 'reg-3', viewValue: 'Severovzhod'},
    {value: 'reg-4', viewValue: 'Jugozahod'},
    {value: 'reg-5', viewValue: 'Visokogorje'},
    {value: 'reg-6', viewValue: 'Prehodna'}
  ];

  sezona: Sezona[] = [
    {value: 'sezona-0', viewValue: 'Leto'},
    {value: 'sezona-1', viewValue: 'Zima'},
    {value: 'sezona-2', viewValue: 'Pomlad'},
    {value: 'sezona-3', viewValue: 'Poletje'},
    {value: 'sezona-4', viewValue: 'Jesen'},
  ];

  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ];

  obdobje: Obdobje[] = [
    {value: 'obdobje-0', viewValue: 'Bližnja prihodnost (2011-2040)'},
    {value: 'obdobje-1', viewValue: 'Sredina stoletja (2041-2070)'},
    {value: 'obdobje-2', viewValue: 'Konec stoletja (2071-2100)'},
  ];

  constructor() { }

  ngOnInit() {
  }

}
